export function formatMillionsNumber(
  num: number,
  showThousands = false,
): string {
  if (num >= 1000000) {
    if (num % 1000000 === 0) {
      return `${num / 1000000}M`;
    }

    return `${(num / 1000000).toFixed(1)}M`;
  }

  if (showThousands && num >= 1000) {
    if (num % 1000 === 0) {
      return `${num / 1000}K`;
    }

    return `${(num / 1000).toFixed(1)}K`;
  }

  if (num >= 100000) {
    return `${(num / 1000000).toFixed(1)}M`;
  }

  return num.toString();
}
